import JsBarcode from 'jsbarcode';
import { useEffect, useRef } from 'react';

const BarcodeGen = ({ value, options } = {}) => {
  const barcodeRef = useRef(null);

  useEffect(() => {
    if (barcodeRef.current) {
      JsBarcode(barcodeRef.current, value, options);
    }
  }, [value, options]);

  return <svg ref={barcodeRef}></svg>;
};

export default BarcodeGen;
